import React, { useState, useEffect } from "react";
import { Col, Row, Card, Form, Button } from '@themesberg/react-bootstrap';
import { useHistory } from "react-router-dom";

export const GeneralInfoForm = ({ user, onSubmit }) => {
  const history = useHistory();
  const [form, setForm] = useState({
    name: "",
    age: "",
    phone: "",
    email: "",
    gender: "",
    // interested_in: "",
    location: "",
    church_name: "",
    church_visit: "",
    marital_status: "",
    education_level: "",
    occupation: "",
    looking_for: "",
    interests: [],
    status: ""
  });

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        age: user.age?.toString() || "",
        gender: user.gender?.toString() || "",
        phone: user.phone || "",
        email: user.email || "",
        location: user.location || "",
        // interested_in: user.interested_in?.toString() || "",
        church_name: user.church_name || "",
        church_visit: user.church_visit?.toString() || "",
        marital_status: user.martial_status?.toString() || "",
        education_level: user.education_level?.toString() || "",
        occupation: user.occupation || "",
        looking_for: user.looking_for || "",
        interests: Array.isArray(user.interests)
          ? user.interests
          : user.interests
          ? String(user.interests).split(",").map(i => i.trim())
          : [],
        status: user.status?.toString() || ""
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, multiple, options } = e.target;

    if (multiple) {
      const selectedValues = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);
      setForm((prev) => ({ ...prev, [name]: selectedValues }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(form);
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">General information</h5>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="name"
                  value={form.name}
                  placeholder="Enter your name"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="age">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  required
                  type="number"
                  name="age"
                  value={form.age}
                  placeholder="Enter your age"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  disabled
                  type="email"
                  name="email"
                  value={form.email}
                  placeholder="name@company.com"
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  name="gender"
                  value={form.gender}
                  onChange={handleChange}
                >
                  <option value="">Gender</option>
                  <option value="2">Male</option>
                  <option value="1">Female</option>
                  <option value="3">Others</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={form.phone}
                  placeholder="+12-345 678 910"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="martial_status">
                <Form.Label>Marital Status</Form.Label>
                <Form.Select
                  name="martial_status"
                  value={form.martial_status}
                  onChange={handleChange}
                >
                  <option value="">Marital Status</option>
                  <option value="1">Single</option>
                  <option value="2">Married</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="education_level">
                <Form.Label>Education Level</Form.Label>
                <Form.Select
                  name="education_level"
                  value={form.education_level}
                  onChange={handleChange}
                >
                  <option value="">Education Level</option>
                  <option value="1">High School</option>
                  <option value="2">Graduation</option>
                  <option value="3">Postgraduate</option>
                  <option value="4">Doctorate</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="occupation">
                <Form.Label>Occupation</Form.Label>
                <Form.Control
                  type="text"
                  name="occupation"
                  value={form.occupation}
                  placeholder="Enter your occupation"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="interests">
                <Form.Label>Interests</Form.Label>
                <Form.Select
                  multiple
                  name="interests"
                  value={form.interests}
                  onChange={handleChange}
                >
                  <option value="1">Photography</option>
                  <option value="2">Shopping</option>
                  <option value="3">Sing</option>
                  <option value="4">Pray</option>
                  <option value="5">Read the Bible</option>
                  <option value="6">Listen to songs</option>
                  <option value="7">Run</option>
                  <option value="8">Swim</option>
                  <option value="9">Make Art</option>
                  <option value="10">Travel</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Select
                name="looking_for"
                value={form.looking_for}
                onChange={handleChange}
              >
                <option value="">Looking For</option>
                <option value="1">Friendship</option>
                <option value="2">Affair</option>
                <option value="3">Casamento</option>
              </Form.Select>
            </Col>
          </Row>

          <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="church_name">
                <Form.Label>Church Name</Form.Label>
                <Form.Control
                  type="text"
                  name="church_name"
                  value={form.church_name}
                  placeholder="Enter your church name"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group id="church_visit">
                <Form.Label>Church Visit</Form.Label>
                <Form.Select
                  name="church_visit"
                  value={form.church_visit}
                  onChange={handleChange}
                >
                  <option value="">Church Visit</option>
                  <option value="1">Daily</option>
                  <option value="2">Weekly</option>
                  <option value="3">Monthly</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="location">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="location"
                  value={form.location}
                  placeholder="Enter your location"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="mt-3">
            <Button variant="primary" type="button" onClick={() => history.goBack()}>
              Back
            </Button>
            <Button style={{ float: "right" }} variant="primary" type="submit">
              Save All
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};
